import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { DossierPage } from './pages/DossierPage';

// La landing /bible se carga bajo demanda para no pesar en la ruta principal.
const BiblePage = lazy(() => import('./pages/BiblePage').then(module => ({
  default: module.BiblePage
})));
interface AppProps {
  /** Cupos restantes mostrados en la barra de urgencia. */
  spotsLeft?: number;
  /** Revela los folios narrativos con barras de censura al entrar en pantalla. */
  redactedIntros?: boolean;
}
export function App({
  spotsLeft = 14,
  redactedIntros = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="31bianp7oiogh">
      <Routes data-id="element-1" data-mp="31c1l6kv02akh">
        <Route path="/" element={<DossierPage spotsLeft={spotsLeft} redactedIntros={redactedIntros} data-id="element-3" data-mp="2wj8ehrfz0s5r" />} data-id="element-2" data-mp="31cjp83nwlt2y" />
        <Route path="/bible" element={<Suspense fallback={<div className="min-h-screen w-full bg-[#0b0b0e]" aria-hidden="true" data-id="element-6" data-mp="3ijxsv0nzqion" />} data-id="element-5" data-mp="23ujho4ly78zt">
              <BiblePage data-id="element-7" data-mp="3ml12v6jcxkhy" />
            </Suspense>} data-id="element-4" data-mp="28s2ztflro5x1" />
      </Routes>
    </BrowserRouter>;
}